import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

const navItems = [
  { label: "Home", link: "#home" },
  { label: "Our Services", link: "#services" },
  { label: "Portfolio", link: "#portfolio" },
  { label: "Why Choose Us", link: "#whyus" },
  { label: "Contact Us", link: "#leadform", cta: true },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState("#home");

  // 🔹 Detect active section on scroll
  useEffect(() => {
    const sections = navItems.map((item) =>
      document.querySelector(item.link)
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(`#${entry.target.id}`);
          }
        });
      },
      { threshold: 0.6 }
    );

    sections.forEach((section) => {
      if (section) observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Logo */}
        <div className="logo">RadianceCloud</div>

        {/* Desktop Nav */}
        <div className="desktop-nav">
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.link}
              className={`nav-link 
                ${active === item.link ? "active" : ""} 
                ${item.cta ? "cta" : ""}`}
            >
              {item.label}
              {!item.cta && <span className="nav-underline" />}
            </a>
          ))}
        </div>

        {/* Hamburger */}
        <div
          className={`mobile-menu-button ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          <span />
          <span />
          <span />
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="mobile-nav"
        >
          {navItems.map((item, index) => (
            <a
              key={index}
              href={item.link}
              className={`mobile-nav-link ${
                active === item.link ? "active" : ""
              }`}
              onClick={() => setIsOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </motion.div>
      )}

      {/* CSS */}
      <style jsx>{`
        .navbar {
          position: fixed;
          top: 0;
          width: 100%;
          z-index: 9999;
          background: rgba(2, 6, 23, 0.95);
          backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(148, 163, 184, 0.15);
        }

        .nav-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 14px 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .logo {
          font-size: 1.3rem;
          font-weight: 800;
          background: linear-gradient(90deg, #38bdf8, #6366f1);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .desktop-nav {
          display: flex;
          gap: 28px;
          align-items: center;
        }

        .nav-link {
          position: relative;
          color: #e5e7eb;
          font-size: 0.95rem;
          font-weight: 500;
          text-decoration: none;
          padding-bottom: 4px;
          transition: color 0.3s ease;
        }

        .nav-link.active {
          color: #38bdf8;
        }

        .nav-underline {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 0%;
          height: 2px;
          background: #38bdf8;
          transition: width 0.3s ease;
        }

        .nav-link.active .nav-underline {
          width: 100%;
        }

        /* 🔹 Contact CTA */
        .nav-link.cta {
          padding: 6px 16px;
          border-radius: 999px;
          background: linear-gradient(90deg, #38bdf8, #2563eb);
          color: #020617;
          font-weight: 600;
        }

        .nav-link.cta:hover {
          opacity: 0.9;
        }

        /* Hamburger */
        .mobile-menu-button {
          display: none;
          flex-direction: column;
          cursor: pointer;
          gap: 5px;
        }

        .mobile-menu-button span {
          width: 25px;
          height: 3px;
          background: #38bdf8;
          border-radius: 2px;
          transition: all 0.3s ease;
        }

        .mobile-menu-button.open span:nth-child(1) {
          transform: rotate(45deg) translateY(8px);
        }

        .mobile-menu-button.open span:nth-child(2) {
          opacity: 0;
        }

        .mobile-menu-button.open span:nth-child(3) {
          transform: rotate(-45deg) translateY(-8px);
        }

        /* Mobile nav */
        .mobile-nav {
          width: 100%;
          background: rgba(2, 6, 23, 0.95);
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 15px 0;
        }

        .mobile-nav-link {
          width: 100%;
          text-align: center;
          padding: 12px 0;
          font-size: 1.1rem;
          font-weight: 500;
          color: #e5e7eb;
          text-decoration: none;
          border-bottom: 1px solid rgba(148, 163, 184, 0.2);
        }

        .mobile-nav-link.active {
          color: #38bdf8;
        }

        @media (max-width: 768px) {
          .desktop-nav {
            display: none;
          }
          .mobile-menu-button {
            display: flex;
          }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
